import { useZero } from "@rocicorp/zero/react";
import { useState } from "react";
import { sharedMutators } from "../../../shared/mutators";
import { Button } from "../Button";
import { ConfirmModal } from "../ConfirmModal";
import { useToast } from "../Toast";

export function ResetBranchDataButton({ branchId }: { branchId: string }) {
  const z = useZero();
  const { showToast } = useToast();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const reset = () => {
    setConfirmOpen(false);
    void z
      .mutate(sharedMutators.resetBranchVolumeData({ branchId }))
      .server.then((result) => {
        if (result.type === "error") {
          showToast({
            icon: "circle-off",
            message: result.error.message,
            buttonLabel: "Dismiss",
          });
        }
      });
  };

  return (
    <>
      <Button
        size="l"
        variant="secondary"
        icon="rotate-ccw"
        onClick={() => setConfirmOpen(true)}
      >
        Reset data
      </Button>
      <ConfirmModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={reset}
        title="Reset this draft’s stored data?"
        description="Every file stored by this draft is deleted, and you can copy live’s data into it or start empty again. Live’s data is not affected."
        confirmLabel="Reset"
        destructive
      />
    </>
  );
}
